import type { AdminTeacherPayoutVM, TeacherPayoutListPaginationParams } from "@shared-kernel/application/ports/admin/admin-repository";
import type { PaginatedResult } from "@shared-kernel/domain/types/paginated-result";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const adminRetrieveTeacherPayouts = createApiThunk<PaginatedResult<AdminTeacherPayoutVM>, TeacherPayoutListPaginationParams>(
  "payouts/adminRetrieveTeacherPayouts",
  async (params: TeacherPayoutListPaginationParams, { extra: { adminRepository } }) => {
    return adminRepository!.getAdminTeacherPayouts(params);
  },
);
